import { Button, Dialog, Modal, Typography } from '@finam/web-ui-kit';
import React from 'react';
import { ICommunityShort } from '../Services/ResponseData';
import { WebService } from '../Services/WebService';
import { TokenContext } from '../TokenContext';
import './Widgets.scss'
import CommunityDescription from './CommunityDescription';

interface IState {
    communities: ICommunityShort[],
    selectedId?: number
}

export default class CommunititesWidget extends React.Component<{}, IState>{
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;

    constructor(props: any) {
        super(props);
        this.state = { communities: [] };
    }

    componentDidMount() {
        new WebService(this.context.token).GetCommunities().then(res => this.setState({ communities: res }));
    }

    render(): React.ReactNode {
        return <div>
            <div className='community-items__wrapper'>
                {this.state.communities.map((item, i) =>
                    <div className='community-items__item' key={`community_${i}`} onClick={() => this.setState({ selectedId: item.id })}>
                        <img src={`data:image/jpeg;base64,${item.image64}`} alt={item.title} title={item.title} />
                        <span style={{minWidth: '100px'}}>{item.title}</span>
                    </div>)}
            </div>
            <Dialog open={!!this.state.selectedId && this.state.selectedId > 0} onBackdropClick={(e) => { e.stopPropagation(); this.setState({ selectedId: 0 }) }}>
                <div className='communities-dialog'>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
                        <img style={{ cursor: 'pointer' }} src={process.env.PUBLIC_URL + 'icons/Close.svg'} onClick={(e) => { e.stopPropagation(); this.setState({ selectedId: 0 }); }} />
                    </div>
                    <CommunityDescription id={this.state.selectedId || 0} />
                </div>
            </Dialog>
        </div>
    }
}